import type * as React from 'react';

import {
    Description,
    FieldGroup,
    Group,
    Label,
    Panel,
    PanelBody,
    Switch,
} from '@gitbook/spine-react';

import { DocumentationLink } from '../../..';
import type { SitesCustomizationPanelProps } from '../../types';

export function PanelPage(props: SitesCustomizationPanelProps): React.ReactElement {
    const { settings, setSettings } = props;

    return (
        <Panel aria-label="Page">
            <PanelBody>
                <FieldGroup orientation="horizontal">
                    <Group>
                        <Label>Pagination</Label>
                        <Description>
                            Show previous/next navigation buttons at the bottom of each page. To
                            hide these controls on a specific page, open the Space and the{' '}
                            <DocumentationLink path="published-documentation/customization/page-layouts">
                                Page options
                            </DocumentationLink>{' '}
                            for any Space.
                        </Description>
                    </Group>
                    <Switch
                        value={settings.pagination.enabled !== false}
                        onValueChange={(showPagination) => {
                            setSettings((prev) => ({
                                ...prev,
                                pagination: {
                                    enabled: showPagination,
                                },
                            }));
                        }}
                    />
                </FieldGroup>
            </PanelBody>
        </Panel>
    );
}
